import { expandValue } from 'lib/rpcts'
import { UIConversation, UIConversationRef, UIConversationView, UIMessageRef } from 'pbts/c1/api/conversations/v1/conversations'
import { UIConversationsSearchServiceClient, UIConversationsServiceClient, UIMessagesSearchServiceClient, UIMessagesServiceClient } from 'pbts/c1/api/conversations/v1/conversations.client'
import { FacetValue } from 'pbts/c1/api/search/v1/facet'
import { SearchTermsResponse } from 'pbts/c1/api/task/v1/search'
import { User } from 'pbts/c1/api/user/v1/user'
import { Any } from 'pbts/google/protobuf/any'
import { createMutationApi } from 'redux_toolkit/lib/createMutationApi'
import { createPagedListApi } from './lib/createPagedListApi'
import { createUnaryApi } from './lib/createUnaryApi'

export interface UIConversationValue extends UIConversation {
    user?: User
}

export const expandConversationView = (msg: UIConversationView | undefined, values: Any[]): UIConversationValue => {
    const a: UIConversationValue = UIConversation.create(msg?.conversation ?? {})
    a.user = expandValue<User>(msg?.userPath, User, values)
    return a
}

const transformUIConversationValueArrayResponse = (resp): Array<UIConversationValue> => {
    return resp.list.map((v): UIConversationValue => expandConversationView(v, resp.expanded))
}

export const createConversationApi = createMutationApi(
    UIConversationsServiceClient,
    'create',
    undefined,
    UIConversationRef.typeName,
)

export const deleteConversationApi = createMutationApi(
    UIConversationsServiceClient,
    'delete',
    undefined,
    UIConversationRef.typeName,
)

export const mutateConversationApi = createMutationApi(
    UIConversationsServiceClient,
    'mutate',
    undefined,
    UIConversationRef.typeName,
)

export const searchConversationApi = createPagedListApi(
    UIConversationsSearchServiceClient,
    'search',
    transformUIConversationValueArrayResponse,
    UIConversationRef.typeName,
)

const transformFacetResponse = (d: SearchTermsResponse): Array<FacetValue> => {
    const item = d?.facets?.facets?.[0]?.item
    return item?.oneofKind === 'value' ? item.value?.values : []
}

export const getSearchTermsApi = createUnaryApi(
    UIConversationsSearchServiceClient,
    'getSearchTerms',
    transformFacetResponse,
)

export const sendMessageApi = createMutationApi(
    UIMessagesServiceClient,
    'send',
)

export const listMessagesApi = createPagedListApi(
    UIMessagesServiceClient,
    'list',
    undefined,
    UIMessageRef.typeName,
)

export const searchMessagesApi = createPagedListApi(
    UIMessagesSearchServiceClient,
    'search',
    undefined,
    UIMessageRef.typeName,
)

export const createMessageFeedbackApi = createMutationApi(
    UIMessagesServiceClient,
    'createFeedback',
)

export const listTicketBindingsApi = createPagedListApi(
    UIConversationsServiceClient,
    'listTicketBindings',
    undefined,
    UIConversationRef.typeName,
)
